export default "__VITE_ASSET__f13c8a04__"